import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "side-menu-item__inner" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "side-menu-item__txt"
}
const _hoisted_4 = {
  key: 0,
  class: "side-menu-item__contents"
}

import { ref, withDefaults } from "vue";
import {
  mapModifires,
  type typeModifires,
  mergeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  text?: string;
  narrow?: boolean;
  opend?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'side-menu-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    text: {},
    narrow: { type: Boolean },
    opend: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;



const isOpend = ref<boolean>(props.opend);

const componentClass = () =>
  mapModifires(
    "side-menu-item",
    mergeModifires(props.modifires, isOpend.value && "opend")
  );

const toggle = () => {
  isOpend.value = !isOpend.value;
};


const handleClick = (e: Event) => {
  emit("click", e);
  toggle();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["side-menu-item__btn", { 'side-menu-item__btn_narrow': _ctx.narrow }]),
        onClick: _withModifiers(handleClick, ["self"])
      }, [
        (_ctx.$slots.text)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _renderSlot(_ctx.$slots, "text")
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2)
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})